import memoize from 'lodash/memoize';
import throttle from 'lodash/throttle';
import { inBrowser } from './commonUtil';
import global from 'global';

function clearCacheSync() {
  getFromSession.cache.clear();
  getFromLocal.cache.clear();
}

const clearCacheAsync = throttle(clearCacheSync, 1000, { leading: false });

const runtimeSession = (global.__meo_runtimeSession = global.__meo_runtimeSession || {});
const runtimeLocal = (global.__meo_runtimeLocal = global.__meo_runtimeLocal || {});

function getFromRuntimeStorage(storage, key) {
  if (!(key in storage)) return null;
  return storage[key];
}

export const obj2json = obj => {
  if (obj === undefined) return 'undefined';
  return JSON.stringify(obj);
};

export const json2obj = jsonStr => {
  if (jsonStr === '') return null;
  if (jsonStr === 'undefined') return undefined;
  return JSON.parse(jsonStr);
};

function checkExpire(obj, key) {
  if (
    typeof obj == 'object' &&
    obj &&
    /^__storage_expire_timestamp(,__storage_value_object)?$/.test(Object.keys(obj).join(','))
  ) {
    const { __storage_expire_timestamp: expire, __storage_value_object: value } = obj;
    if (typeof expire == 'number' && expire < Date.now()) {
      return removeFromLocal(key);
    } else {
      return value;
    }
  }
  return obj;
}

export const set2Session = (key, value) => {
  clearCacheSync();
  if (inBrowser()) {
    sessionStorage.setItem(key, obj2json(value));
  } else {
    runtimeSession[key] = obj2json(value);
  }
};

export const set2Local = (key, value, expire = null) => {
  clearCacheSync();
  if (expire instanceof Date) expire = expire.getTime();
  if (typeof expire == 'number' && expire < Date.now()) return removeFromLocal(key);
  value = { __storage_expire_timestamp: expire, __storage_value_object: value };
  if (inBrowser()) {
    localStorage.setItem(key, obj2json(value));
  } else {
    runtimeLocal[key] = obj2json(value);
  }
};

export const getFromSession = memoize(key => {
  clearCacheAsync();
  if (inBrowser()) {
    const jsonStr = sessionStorage.getItem(key);
    return json2obj(jsonStr);
  } else {
    const jsonStr = getFromRuntimeStorage(runtimeSession, key);
    return json2obj(jsonStr);
  }
});

export const getFromLocal = memoize(key => {
  clearCacheAsync();
  let value;
  if (inBrowser()) {
    const jsonStr = localStorage.getItem(key);
    value = json2obj(jsonStr);
  } else {
    const jsonStr = getFromRuntimeStorage(runtimeLocal, key);
    value = json2obj(jsonStr);
  }
  return checkExpire(value, key);
});

export const removeFromSession = key => {
  clearCacheSync();
  if (inBrowser()) {
    sessionStorage.removeItem(key);
  } else {
    delete runtimeSession[key];
  }
};

export const removeFromLocal = key => {
  clearCacheSync();
  if (inBrowser()) {
    localStorage.removeItem(key);
  } else {
    delete runtimeLocal[key];
  }
};

export default {
  obj2json,
  json2obj,
  set2Session,
  set2Local,
  getFromSession,
  getFromLocal,
  removeFromSession,
  removeFromLocal,
};
